/* eslint import/no-webpack-loader-syntax: off */
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

mapboxgl.accessToken = import.meta.env.VITE_MAPBOX_TOKEN;

export default mapboxgl;
export const mapStyles = {
  satellite: 'mapbox://styles/koshat/ckcukqr8a3vp41ipcjsb4m5xn',
  simple: 'mapbox://styles/koshat/ckh65bi730x7u19qez3r66f27'
};
